import React from 'react'
import {Icon} from '@chakra-ui/react'

const StarIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path
                d="M29.1877 37.9976C28.3516 37.9976 27.506 37.7324 26.7756 37.2114L21.5285 33.4506C20.6156 32.7969 19.3855 32.7969 18.4725 33.4506L13.2255 37.2114C11.7551 38.2629 9.86196 38.2629 8.39163 37.2114C6.9213 36.1599 6.33509 34.3789 6.90208 32.6832L8.91057 26.6015C9.25653 25.5406 8.88174 24.3943 7.96879 23.7407L2.72172 19.9799C1.23217 18.9189 0.645956 17.1474 1.21295 15.4423C1.77994 13.7371 3.30793 12.6477 5.12422 12.6477H11.611C12.745 12.6477 13.7348 11.9372 14.0808 10.8763L16.0893 4.79455C16.6466 3.0894 18.1842 2 20.0005 2C21.8168 2 23.3448 3.09888 23.9118 4.79455L25.9203 10.8763C26.2663 11.9372 27.2657 12.6477 28.3901 12.6477H34.8768C36.6931 12.6477 38.2211 13.7466 38.7881 15.4423C39.3551 17.138 38.7593 18.9189 37.2986 19.9704L32.0515 23.7312C31.1385 24.3848 30.7541 25.5406 31.1097 26.6015L33.1182 32.6832C33.6756 34.3789 33.0894 36.1599 31.6287 37.2114C30.8983 37.7324 30.0526 37.9976 29.2165 37.9976H29.1877Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default StarIcon
